module.exports = __webpack_public_path__ + "static/media/fineos.9577e3f1.png";